import { RetailhubEvents } from "./core/RetailhubEvents";
import type { RetailhubEventsConstructorOptions } from "./types";

// Declare global window interface
declare global {
  interface Window {
    RetailHub: {
      events: ReturnType<typeof RetailhubEvents>;
    };
  }
}

// Initialize RetailHub namespace if it doesn't exist
if (typeof window !== "undefined") {
  if (!window.RetailHub) {
    window.RetailHub = {} as any;
  }

  // Check if debug cookie exists
  const hasDebugCookie = document.cookie.split(';').some(cookie =>
    cookie.trim().startsWith('debug=')
  );

  // Auto-initialize events with default options
  const defaultOptions: RetailhubEventsConstructorOptions = {
    listenerLimit: 100,
    initialEvents: [],
    logEnabled: hasDebugCookie,
  };

  window.RetailHub.events = RetailhubEvents(defaultOptions);

  console.log("✅ RetailHub Events Manager initialized at window.RetailHub.events");
  if (hasDebugCookie) {
    console.log("🐛 Debug mode enabled via cookie");
  }
}

export { RetailhubEvents };
export type {
  RetailhubEventsData,
  Callback,
  ListenerOptions,
  RetailhubEventsConstructorOptions,
} from "./types";
